/* Canyon Bites storefront — every page shares the Site settings config (window.CB, from the canyon-chrome section).
   Cart runs on the Shopify Ajax Cart API; checkout is Shopify's. */
(function () {
  "use strict";
  const ORDER = ["cinnamon", "ranch", "spicy"];
  const FC = { cinnamon: "#F6BE1F", ranch: "#A9CDEC", spicy: "#E9441F" };
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
  const once = (el, key) => { if (!el) return false; const k = "cb" + key; if (el.dataset[k]) return false; el.dataset[k] = "1"; return true; };
  const esc = s => String(s ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const money = c => "$" + (Math.round(c) / 100).toFixed(2); // cents in
  const ls = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  let CFG = null, cartState = null, sel = null, qi = 0, homeTimers = [], spinning = false, wheelRot = 0;
  const readCfg = () => {
    const el = $("#cb-config"); try { CFG = JSON.parse(el.textContent); } catch (e) { CFG = window.CB || null; }
    // auto launch: a page cached before launch time still switches to live on the visitor's clock
    if (CFG && CFG.pre && CFG.modeSetting === "auto" && CFG.launchTs && Date.now() / 1000 >= CFG.launchTs) {
      CFG.pre = false; CFG.subsOn = !(CFG.subs && CFG.subs.enabled === false);
      const d = document.documentElement; d.dataset.mode = "live"; d.dataset.subs = CFG.subsOn ? "on" : "off";
    }
    window.CB = CFG; return CFG;
  };

  /* ---------- pricing ---------- */
  const F = k => (CFG.flavors && CFG.flavors[k]) || {};
  const okFlavor = k => F(k).variant > 0 && F(k).available !== false;
  const tiers = () => (CFG.pricing.tiers || []).filter(t => t.min > 0 && t.pct > 0).sort((a, b) => a.min - b.min);
  const pctFor = n => tiers().reduce((p, t) => (n >= t.min ? Math.max(p, t.pct) : p), 0);
  const countOf = c => ORDER.reduce((s, k) => s + (c[k] || 0), 0);
  const fullOf = c => ORDER.reduce((s, k) => s + (c[k] || 0) * (F(k).price || 0), 0);
  const maxBags = () => CFG.pricing.maxBags || 99;
  const minBags = () => Math.max(1, CFG.pricing.minBags || 1);
  const shipBags = () => CFG.pricing.freeShipBags || 0; // free shipping by bag count (0 = by dollars)
  const shipLeft = (n, cents) => shipBags() ? Math.max(0, shipBags() - n) : Math.max(0, CFG.pricing.freeShip * 100 - cents);
  const shipIntro = () => shipBags() ? `Free shipping on ${shipBags()}+ bags` : `Free shipping on orders $${CFG.pricing.freeShip}+`;
  const shipTo = (n, cents) => { const l = shipLeft(n, cents); return shipBags() ? `Add ${l} more bag${l > 1 ? "s" : ""} for free shipping` : `${money(l)} away from free shipping`; };
  // Subscribe & save copy and options come from HQ (shop metafield canyon.site → subs)
  const SUB = () => Object.assign({ label: "Subscribe & save", note: "Skip or cancel anytime", start: "sub", hide: [], perks: null }, (CFG && CFG.subs) || {});
  const planOn = p => !(SUB().hide || []).some(h => h && (h === p.opt || h === p.name));
  const plansOf = list => (list || []).filter(planOn);
  const planLabel = p => { const t = String((p && (p.opt || p.name)) || "").replace(/^deliver(ed|y)?\s+/i, ""); return t.charAt(0).toUpperCase() + t.slice(1); };
  function freqLabel(name) { for (const k of ORDER) { const p = (F(k).plans || []).find(x => x.name === name); if (p) return planLabel(p); } return name; }
  function freqs() {
    const names = ORDER.filter(okFlavor).map(k => plansOf(F(k).plans).map(p => p.name));
    if (!names.length || names.some(n => !n.length)) return [];
    return names[0].filter(n => names.every(l => l.includes(n)));
  }
  const subsAvailable = () => CFG.subsOn && freqs().length > 0;
  function subPrice(c, freqName) {
    return ORDER.reduce((s, k) => {
      const n = c[k] || 0; if (!n) return s;
      const p = (F(k).plans || []).find(x => x.name === freqName);
      return s + n * (p ? p.price : F(k).price);
    }, 0);
  }
  function estimate(c, sub) {
    const n = countOf(c), pct = pctFor(n);
    const base = sub ? subPrice(c, freqs()[sel ? sel.freq : 0]) : fullOf(c);
    return base * (1 - pct / 100);
  }
  function tierHTML(n) {
    const T = [{ min: minBags(), pct: 0 }, ...tiers()];
    return T.map((t, i) => {
      const nx = T[i + 1], on = n >= t.min && (!nx || n < nx.min);
      const range = nx ? (nx.min - 1 > t.min ? `${t.min}–${nx.min - 1} bags` : `${t.min} bag${t.min > 1 ? "s" : ""}`) : `${t.min}+ bags`;
      return `<div class="tier ${on ? "on" : ""}"><b>${t.pct ? t.pct + "% off" : (i === 0 && minBags() > 1 ? "Full price" : "0%")}</b><span>${range}</span></div>`;
    }).join("");
  }

  /* ---------- helpers ---------- */
  let tt;
  function toast(m) { const t = $("#toast"); if (!t) return; t.textContent = m; t.classList.add("show"); clearTimeout(tt); tt = setTimeout(() => t.classList.remove("show"), 2600); }
  const url = p => (CFG.root || "/").replace(/\/$/, "") + p;
  async function api(path, body) {
    const r = await fetch(url(path), body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) } : { headers: { Accept: "application/json" } });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw Object.assign(new Error(j.description || j.message || "Cart error"), { status: r.status });
    return j;
  }
  const isWelcome = c => { const up = String(c || "").toUpperCase(), d = savedCode(); return /^CB-[A-Z0-9]{6}$/.test(up) || !!(d && d.code === up); };
  const bundleMin = () => (tiers()[0] || { min: 1e9 }).min;
  const welcomeOk = c => !c || c.item_count < bundleMin();
  // the welcome code is for orders below the first bag deal. It never goes over a creator's code (they get credit for the sale).
  function codeFix(c) {
    const d = savedCode(), codes = (c && c.discount_codes) || [];
    if (d && !d.off && !codes.length && welcomeOk(c)) return d.code;
    if (codes.length && codes.every(x => isWelcome(x.code)) && !welcomeOk(c)) return "";
  }
  /* quantity steppers: the number changes on tap, one request goes out once tapping stops */
  const pend = {}; let qChain = Promise.resolve();
  const lineOf = k => cartState && cartState.items.find(i => i.key === k);
  const optCount = () => cartState ? cartState.items.reduce((s, i) => s + (pend[i.key] ? pend[i.key].q : i.quantity), 0) : 0;
  function paintLine(k, q, l) {
    $$("[data-line]").forEach(el => {
      if (el.dataset.line !== k) return;
      const o = el.querySelector("output"); o.textContent = q; o.classList.remove("bump"); void o.offsetWidth; o.classList.add("bump");
      const lp = el.querySelector("[data-lp]"); if (lp && l.quantity) lp.textContent = money(Math.round(l.final_line_price / l.quantity * q));
      el.classList.toggle("leaving", q === 0);
    });
    $$('[data-cart="count"]').forEach(e => e.textContent = optCount());
    $$("[data-cart-root]").forEach(r => r.classList.add("syncing"));
  }
  function stepLine(k, step) {
    const l = lineOf(k); if (!l) return;
    const cur = pend[k] ? pend[k].q : l.quantity, q = Math.max(0, cur + step), max = maxBags();
    if (step > 0 && optCount() >= max) { toast(`Max ${max} bags per order`); return; }
    if (q === cur) return;
    const p = pend[k] || (pend[k] = {}); p.q = q; clearTimeout(p.t);
    paintLine(k, q, l);
    p.t = setTimeout(() => flushLine(k), 320);
  }
  function flushLine(k) {
    const p = pend[k]; if (!p) return qChain; clearTimeout(p.t); p.t = null;
    const q = p.q;
    return qChain = qChain.then(async () => {
      try {
        let c = await api("/cart/change.js", { id: k, quantity: q });
        const fix = codeFix(c); if (fix !== undefined) c = await api("/cart/update.js", { discount: fix });
        cartState = c;
      } catch (e) { toast("Couldn't update your bag"); try { cartState = await api("/cart.js"); } catch (_) {} delete pend[k]; }
      if (pend[k] === p && p.q === q && !p.t) delete pend[k];
      if (!Object.keys(pend).length) { renderCart(); $$("[data-cart-root]").forEach(r => r.classList.remove("syncing")); }
    });
  }
  const flushAll = () => Promise.all(Object.keys(pend).map(flushLine)).then(() => qChain);

  /* clear the bag, with a few seconds to undo */
  const snapItems = c => (c.items || []).map(i => Object.assign({ id: i.variant_id, quantity: i.quantity }, i.selling_plan_allocation ? { selling_plan: i.selling_plan_allocation.selling_plan.id } : {}, i.properties && Object.keys(i.properties).length ? { properties: i.properties } : {}));
  let undoT = null;
  function undoBar(msg, onUndo) {
    let u = $("#cbUndo");
    if (!u) { u = document.createElement("div"); u.id = "cbUndo"; u.className = "undobar"; u.setAttribute("role", "status"); document.body.appendChild(u); }
    u.innerHTML = `<span>${esc(msg)}</span><button type="button" class="press">Undo</button>`;
    requestAnimationFrame(() => u.classList.add("show"));
    const hide = () => { u.classList.remove("show"); clearTimeout(undoT); };
    clearTimeout(undoT); undoT = setTimeout(hide, 6000);
    u.querySelector("button").onclick = async () => { hide(); try { await onUndo(); } catch (e) { toast("Couldn't bring your bag back"); } };
  }
  async function clearBag(btn) {
    if (!cartState || !cartState.item_count) return;
    const snap = { items: snapItems(cartState), codes: (cartState.discount_codes || []).map(x => x.code) }, n = cartState.item_count;
    Object.keys(pend).forEach(k => { clearTimeout(pend[k].t); delete pend[k]; });
    if (btn) btn.classList.add("busy");
    try { cartState = await api("/cart/clear.js", {}); } catch (e) { toast("Couldn't clear your bag"); if (btn) btn.classList.remove("busy"); return; }
    $$("[data-cart-root]").forEach(r => r.classList.remove("syncing"));
    renderCart(); saveBag(true);
    undoBar(`Removed ${n} bag${n > 1 ? "s" : ""}`, async () => {
      await api("/cart/add.js", { items: snap.items });
      if (snap.codes.length) await api("/cart/update.js", { discount: snap.codes.join(",") });
      cartState = await syncExtras(); renderCart();
    });
  }

  /* signed-in customers: the bag is saved to their account (CRM "Saved bags" tab) and follows them to any device */
  const ACCT = () => (CFG && CFG.acct) || {};
  const bagOn = () => { const A = ACCT(); return !!(A.in && A.tok && CFG.crm); };
  const bagList = c => (c.items || []).map(i => ({ id: i.variant_id, q: i.quantity, sp: i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : null }));
  let bagSig = null, bagT = null, bagReady = false, bagBody = null;
  // "who", not "email": an older CRM script rejects this instead of filing it as an affiliate application
  const bagReq = body => { const A = ACCT(); return Object.assign({ cid: String(A.id), tok: A.tok, who: A.email, orders: A.orders }, body); };
  function saveBag(now) {
    if (!bagOn() || !bagReady || !cartState) return;
    const items = bagList(cartState), sig = JSON.stringify(items);
    clearTimeout(bagT); bagBody = null;
    if (sig === bagSig) return;
    bagBody = bagReq({ type: "bag_put", items });
    const send = () => { const b = bagBody; bagBody = null; if (b) crm(b).then(r => { if (r && r.ok) bagSig = sig; }).catch(() => {}); };
    if (now) send(); else bagT = setTimeout(send, 1200);
  }
  // leaving the page before the save goes out: send it anyway
  addEventListener("pagehide", () => { if (bagBody && navigator.sendBeacon) { try { navigator.sendBeacon(CFG.crm, JSON.stringify(bagBody)); bagBody = null; } catch (e) {} } });
  async function restoreBag() {
    if (!bagOn() || bagReady) return;
    const A = ACCT(), key = "cb-bag-" + A.id;
    try {
      if (cartState && cartState.item_count) { bagReady = true; saveBag(); return; }
      let once = false; try { once = sessionStorage.getItem(key) === "1"; sessionStorage.setItem(key, "1"); } catch (e) {}
      const r = once ? null : await crm(bagReq({ type: "bag_get" }));
      bagReady = true;
      if (!r || !r.ok || !(r.items || []).length) { bagSig = "[]"; return; }
      if ((r.orders || 0) < (A.orders || 0)) { bagSig = null; saveBag(true); return; } // they've ordered since: that bag is done
      if (cartState && cartState.item_count) { saveBag(); return; } // they added something while we looked
      const items = r.items.filter(x => x && x.id && x.q > 0).map(x => Object.assign({ id: x.id, quantity: x.q }, x.sp ? { selling_plan: x.sp } : {}));
      try { await api("/cart/add.js", { items }); }
      catch (e) { for (const it of items) { try { await api("/cart/add.js", { items: [it] }); } catch (_) {} } } // a sold-out flavor shouldn't block the rest
      cartState = await syncExtras(); renderCart();
      bagSig = JSON.stringify(bagList(cartState));
      if (cartState.item_count) toast("Welcome back. Your saved bag is ready.");
    } catch (e) { bagReady = true; }
  }
  function savedCode() { try { const d = JSON.parse(ls.get("cb-discount") || "null"); return d && d.code ? d : null; } catch (e) { return null; } }
  const validEmail = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  function setFlavor(f, remember) {
    if (!ORDER.includes(f)) return;
    document.documentElement.dataset.flavor = f;
    if (remember) ls.set("cb-flavor", f);
  }

  /* ---------- cart ---------- */
  async function syncExtras() {
    // pre-order marker on the order + the spin code, stored on the cart itself
    const body = { attributes: CFG.pre ? { "Order type": "Pre-order", "Ships by": CFG.shipDate } : { "Order type": "", "Ships by": "" } };
    const cur = await api("/cart.js").catch(() => cartState), fix = codeFix(cur);
    if (fix !== undefined) body.discount = fix;
    return api("/cart/update.js", body);
  }
  async function addItems(items, btns) {
    items = items.filter(i => i.id && i.quantity > 0); if (!items.length) return false;
    const max = maxBags(), adding = items.reduce((s, i) => s + i.quantity, 0), inCart = cartState ? cartState.item_count : 0;
    if (inCart + adding > max) { toast(`Max ${max} bags per order. You have ${inCart} in your bag.`); openCart(true); return false; }
    (btns || []).forEach(b => b && b.classList.add("busy"));
    try {
      await api("/cart/add.js", { items });
      cartState = await syncExtras();
      renderCart(); openCart(true);
      toast(`${adding} bag${adding > 1 ? "s" : ""} added`);
      return true;
    } catch (e) {
      toast(e.status === 422 ? (e.message || "That flavor isn't available right now") : "Couldn't add to cart. Try again.");
      return false;
    } finally { (btns || []).forEach(b => b && b.classList.remove("busy")); }
  }
  async function loadCart() { try { cartState = await api("/cart.js"); renderCart(); restoreBag(); } catch (e) {} }
  function imgForVariant(id) { const k = ORDER.find(k => F(k).variant === id); return k ? F(k).img : null; }
  // one row per saving: subscribe & save, bundle deal, spin prize / creator code, shipping
  function discLabel(app) {
    const t = String(app.title || app.key || ""), up = t.toUpperCase();
    const pct = app.value_type === "percentage" ? Math.round(+app.value) : null, off = pct ? `${pct}% off` : "";
    if (app.type !== "discount_code") {
      const m = t.match(/(\d+)\+?\s*bags?/i);
      return /bundle/i.test(t) ? `${m ? `${m[1]}+ bag bundle` : "Bundle deal"}${off ? ` · ${off}` : ""}` : t;
    }
    if (up === "PUNCHCARD") return "Punch card reward";
    const spin = savedCode();
    if (/^CB-[A-Z0-9]{6}$/.test(up) || (spin && spin.code === up)) return `Welcome${off ? ` · ${off}` : ""} <small>${esc(up)}</small>`;
    return `Creator code${off ? ` · ${off}` : ""} <small>${esc(up)}</small>`;
  }
  function savingsHTML(c, groups, subSave, saved) {
    const row = (l, v, cls) => `<div class="sub disc ${cls || ""}"><span>${l}</span><span>${v}</span></div>`;
    let h = "";
    if (subSave) { const pct = (c.items.find(i => i.selling_plan_allocation) || {}).selling_plan_allocation; const p = pct && pct.compare_at_price ? Math.round((1 - pct.price / pct.compare_at_price) * 100) : 0; h += row(`Subscribe &amp; save${p ? ` · ${p}% off` : ""}`, "−" + money(subSave)); }
    const isCode = g => g.app.type === "discount_code";
    [...groups.values()].sort((a, b) => isCode(a) - isCode(b)).forEach(g => h += row(discLabel(g.app), "−" + money(g.amt)));
    if (saved) h += `<div class="sub saved-row"><span>Total saved</span><span>${money(saved)}</span></div>`;
    if (c.item_count) {
      const free = shipBags() ? c.item_count >= shipBags() : c.total_price >= CFG.pricing.freeShip * 100;
      h += free ? row(`Shipping${shipBags() ? ` (${shipBags()}+ bags)` : ""}`, "FREE", "ship-free") : `<div class="sub ship-row"><span>Shipping</span><span>At checkout</span></div>`;
    }
    return h;
  }
  function renderCart() {
    const c = cartState; if (!c) return;
    $$('[data-cart="count"]').forEach(e => e.textContent = c.item_count);
    const orig = c.items.reduce((s, i) => s + i.original_line_price, 0);
    // subscribe & save: the plan price is already baked into the line price, so measure it against the one-time price
    const subSave = c.items.reduce((s, i) => { const a = i.selling_plan_allocation; return s + (a && a.compare_at_price > a.price ? (a.compare_at_price - a.price) * i.quantity : 0); }, 0);
    const groups = new Map();
    const addG = (app, amt) => { if (!app || !amt) return; const k = (app.type || "") + ":" + (app.title || app.key || ""); const g = groups.get(k) || { app, amt: 0 }; g.amt += amt; groups.set(k, g); };
    c.items.forEach(i => (i.line_level_discount_allocations || []).forEach(a => addG(a.discount_application, a.amount)));
    (c.cart_level_discount_applications || []).forEach(a => { const app = a.discount_application || a; addG(app, a.amount != null ? a.amount : app.total_allocated_amount); });
    const discTotal = [...groups.values()].reduce((s, g) => s + g.amt, 0);
    const saved = subSave + discTotal;
    const left = shipLeft(c.item_count, c.total_price), code = savedCode(), short = c.item_count ? Math.max(0, minBags() - c.item_count) : 0;
    const linesHTML = c.items.length ? c.items.map(i => {
      const img = imgForVariant(i.variant_id) || i.image || "";
      const plan = i.selling_plan_allocation ? `Subscription · ${esc(i.selling_plan_allocation.selling_plan.name)}` : (CFG.pre ? `Pre-order · ships by ${esc(CFG.shipDate)}` : "One-time");
      return `<div class="lineitem" data-line="${esc(i.key)}"><img src="${esc(img)}" alt=""><div><a class="lname" href="${esc(i.url || "#")}">${esc(i.product_title)}</a><span class="lsub">${plan}</span>
        <div class="lq"><button type="button" class="press" data-key="${esc(i.key)}" data-step="-1" aria-label="One fewer ${esc(i.product_title)}">−</button><output aria-live="polite">${i.quantity}</output><button type="button" class="press" data-key="${esc(i.key)}" data-step="1" aria-label="One more ${esc(i.product_title)}">+</button></div></div>
        <div class="lp" data-lp>${i.final_line_price < i.original_line_price ? `<s>${money(i.original_line_price)}</s>` : ""}${money(i.final_line_price)}</div></div>`;
    }).join("") : `<div class="empty">Your bag is empty.<br>Mix any flavors you like.</div>`;
    $$("[data-cart-root]").forEach(r => {
      const q = n => r.querySelector(`[data-cart="${n}"]`);
      q("subtotal").textContent = money(orig + subSave);
      q("discRow").hidden = true;
      let cb = q("codebox");
      if (!cb) {
        cb = document.createElement("div"); cb.className = "codebox"; cb.dataset.cart = "codebox";
        cb.innerHTML = `<form data-codeform><label class="sr" for="cbCode-${r.dataset.cartRoot || Math.random().toString(36).slice(2, 7)}">Discount or creator code</label><input type="text" name="code" placeholder="Discount or creator code" autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="30"><button type="submit" class="press">Apply</button></form><div class="codechips" data-cart="chips"></div>`;
        const inp = cb.querySelector("input"), lb = cb.querySelector("label"); inp.id = lb.htmlFor;
        q("subtotal").parentNode.before(cb);
      }
      q("chips").innerHTML = (c.discount_codes || []).map(x => {
        const up = String(x.code).toUpperCase(), note = x.applicable ? "" : isWelcome(up) ? (welcomeOk(c) ? "applies at checkout with the email you spun with" : `for orders under ${bundleMin()} bags`) : "can't be used on this order";
        return `<span class="cchip ${x.applicable ? "" : "off"}"><b>${esc(up)}</b>${note ? `<i>${esc(note)}</i>` : ""}<button type="button" class="press" data-rmcode aria-label="Remove ${esc(up)}">×</button></span>`;
      }).join("");
      let bb = q("bagbar");
      if (!bb) {
        bb = document.createElement("div"); bb.className = "bagbar"; bb.dataset.cart = "bagbar";
        bb.innerHTML = `<span data-cart="bagcount"></span><button type="button" class="clearbag press" data-clearbag><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>Clear bag</button>`;
        q("lines").before(bb);
      }
      bb.hidden = !c.item_count;
      q("bagcount").textContent = `${c.item_count} bag${c.item_count === 1 ? "" : "s"}`;
      let ar = q("acctrow");
      if (!ar) { ar = document.createElement("a"); ar.className = "acctrow press"; ar.dataset.cart = "acctrow"; q("checkout").parentNode.appendChild(ar); }
      const A = ACCT();
      if (A.in) { ar.href = A.page || "/pages/account"; ar.innerHTML = `<i aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></i><span><b>${bagOn() ? "Your bag is saved to your account" : "You're signed in"}</b><small>${esc(A.email || "View your account")}</small></span>`; }
      else { const lg = A.login || "/account/login"; ar.href = lg + (lg.includes("?") ? "&" : "?") + "return_url=" + encodeURIComponent(location.pathname + location.search); ar.innerHTML = `<i aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></svg></i><span><b>Sign in to save your bag</b><small>Pick up where you left off on any device</small></span><em aria-hidden="true">›</em>`; }
      let sv = q("savings");
      if (!sv) { sv = document.createElement("div"); sv.className = "savings"; sv.dataset.cart = "savings"; q("discRow").after(sv); }
      sv.innerHTML = savingsHTML(c, groups, subSave, saved);
      q("total").textContent = money(c.total_price);

      q("shipMsg").textContent = !c.item_count ? shipIntro() : short ? `Minimum ${minBags()} bags per order. Add ${short} more to check out.` : left > 0 ? shipTo(c.item_count, c.total_price) : "Free shipping unlocked";
      q("shipBar").style.width = Math.min(100, shipBags() ? (c.item_count / shipBags()) * 100 : (c.total_price / (CFG.pricing.freeShip * 100)) * 100) + "%";
      q("lines").innerHTML = linesHTML;
      q("preNote").hidden = !(CFG.pre && c.item_count);
      const a = q("checkout");
      const otherCode = (c.discount_codes || []).some(x => !code || String(x.code).toUpperCase() !== code.code);
      a.href = url("/checkout") + (code && !code.off && !otherCode && welcomeOk(c) ? "?discount=" + encodeURIComponent(code.code) : "");
      a.setAttribute("aria-disabled", c.item_count && !short ? "false" : "true");
    });
    $$("[data-tier-table]").forEach(t => t.innerHTML = tierHTML(c.item_count));
    saveBag();
  }
  let lastFocus = null;
  function syncScrim() { const s = $("#scrim"); if (s) s.classList.toggle("open", ["#drawer", "#wheelModal"].some(q => { const e = $(q); return e && e.classList.contains("open"); })); }
  function openCart(o) {
    const dr = $("#drawer"); if (!dr) return; const was = dr.classList.contains("open"); if (o === was) return;
    if (o && CFG.template === "cart") { window.scrollTo({ top: 0, behavior: "smooth" }); return; }
    if (o) lastFocus = document.activeElement;
    dr.classList.toggle("open", o); dr.setAttribute("aria-hidden", !o); syncScrim();
    if (o) $("#closeCart").focus({ preventScroll: true }); else if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- email capture → Shopify customers ---------- */
  async function subscribe(email, tags) {
    const fd = new FormData();
    fd.append("form_type", "customer"); fd.append("utf8", "✓");
    fd.append("contact[email]", email); fd.append("contact[tags]", tags);
    const r = await fetch(url("/contact"), { method: "POST", body: fd, headers: { Accept: "text/html" } });
    return r.ok || r.redirected;
  }
  // CRM Google Sheet (HQ → Affiliates → Google Sheet connection): votes, spins and applications land in its tabs
  async function crm(body) {
    if (!CFG.crm) throw new Error("no crm");
    const ctl = typeof AbortController !== "undefined" ? new AbortController() : null, t = setTimeout(() => ctl && ctl.abort(), 12000);
    try { const r = await fetch(CFG.crm, { method: "POST", body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined }); return await r.json(); }
    finally { clearTimeout(t); }
  }

  /* ---------- spin wheel ---------- */
  const WCOL = [["#F6BE1F", "#4A2511"], ["#A9CDEC", "#1D3F8F"], ["#FFF8EC", "#B8300C"], ["#E9441F", "#FFF8EC"]];
  function buildWheel() {
    const S = CFG.wheel.slices, n = S.length, a = 360 / n, c = 200, r = 192, w = $("#wheel"); if (!w || !n) return;
    const pt = (deg, rad) => { const t = (deg - 90) * Math.PI / 180; return [c + rad * Math.cos(t), c + rad * Math.sin(t)]; };
    let g = `<circle cx="200" cy="200" r="198" fill="#1E1410"/>`;
    S.forEach((s, i) => {
      const [bg, fg] = WCOL[i % (n % 4 === 1 ? 3 : 4)], p1 = pt(i * a, r), p2 = pt((i + 1) * a, r);
      g += `<path d="M200 200L${p1[0]} ${p1[1]}A${r} ${r} 0 ${a > 180 ? 1 : 0} 1 ${p2[0]} ${p2[1]}Z" fill="${bg}" stroke="#1E1410" stroke-width="3"/>`;
      const mid = i * a + a / 2, [tx, ty] = pt(mid, r * 0.62), [ox, oy] = pt(mid, r * 0.36);
      const lines = String(s.big || `${s.pct}%`).split(/\n|\|/).map(x => x.trim()).filter(Boolean).slice(0, 2), small = s.big ? (s.small || "") : "OFF";
      const longest = Math.max(...lines.map(x => x.length)), bs = (n > 8 ? 22 : 30) * Math.min(1, (lines.length > 1 ? 7.5 : 5) / Math.max(3, longest));
      const bigSvg = lines.length > 1 ? lines.map((l, k) => `<tspan x="${tx}" dy="${k ? bs * 1.02 : -bs * 0.51}">${esc(l)}</tspan>`).join("") : esc(lines[0]);
      g += `<text x="${tx}" y="${ty}" transform="rotate(${mid} ${tx} ${ty})" text-anchor="middle" dominant-baseline="middle" fill="${fg}" font-family="Lilita One, Arial Rounded MT Bold, sans-serif" font-size="${bs.toFixed(1)}">${bigSvg}</text>${small ? `<text x="${ox}" y="${oy}" transform="rotate(${mid} ${ox} ${oy})" text-anchor="middle" dominant-baseline="middle" fill="${fg}" font-family="Jost, sans-serif" font-weight="800" font-size="${small.length > 8 ? 11 : 13}" letter-spacing="1.5">${esc(small)}</text>` : ""}`;
    });
    g += `<circle cx="200" cy="200" r="34" fill="#1E1410"/><circle cx="200" cy="200" r="26" fill="#FFF8EC"/><text x="200" y="202" text-anchor="middle" dominant-baseline="middle" font-family="Lilita One, sans-serif" font-size="15" fill="#1E1410">SPIN</text>`;
    w.innerHTML = g;
  }
  function openWheel(o) {
    const m = $("#wheelModal"); if (!m) return;
    m.classList.toggle("open", o); m.setAttribute("aria-hidden", !o); syncScrim();
    if (o) { ls.set("cb-wheel-seen", "1"); setTimeout(() => { const i = $("#wemail"); i && i.focus({ preventScroll: true }); }, 350); }
  }
  function wonView(s, repeat) {
    return `<div class="eyebrow">${repeat ? "Welcome back" : "You won"}</div><h2 class="display">${esc(s.pct)}% off your first order</h2>${tiers()[0] ? `<p style="margin:6px 0 0;font-weight:600">Works on orders of ${minBags()}–${tiers()[0].min - 1} bags. At ${tiers()[0].min}+ bags the bundle deal takes over${shipBags() ? ", with free shipping" : ""}. Check out with the email you spun with.</p>` : ""}${repeat ? `<p style="margin:6px 0 0;font-weight:600">This email already spun, so here's your code again. One spin per person.</p>` : ""}
      <div class="won"><b>Saved to your bag</b><p style="margin:4px 0 10px;font-size:14px;font-weight:600">It applies at checkout automatically. Your one-time code, in case you shop on another device:</p><div class="code"><code id="wcode">${esc(s.code)}</code><button type="button" class="press" id="copyCode">Copy</button></div></div>
      <button type="button" class="btn btn-cream press" id="shopNow" style="margin-top:16px">Build your bag</button>`;
  }
  async function spin(email) {
    if (spinning) return; spinning = true;
    const sb = $("#spinBtn"); sb.disabled = true; sb.classList.add("busy");
    const S = CFG.wheel.slices;
    let idx = -1, repeat = null;
    // the CRM sheet picks the prize, hands out a one-time code and remembers the email: one spin per person
    let prize = null;
    try {
      const j = await crm({ type: "spin", email, slices: S.map(s => ({ pct: +s.pct, weight: +s.weight })) });
      if (j && j.ok && j.code) {
        prize = { code: String(j.code).toUpperCase(), pct: +j.pct };
        if (j.repeat) repeat = prize;
        const hits = S.map((s, i) => i).filter(i => +S[i].pct === prize.pct);
        if (hits.length) idx = hits[Math.floor(Math.random() * hits.length)];
      }
    } catch (e) {}
    sb.classList.remove("busy");
    if (!prize) { // no shared fallback codes: wait for the sheet
      spinning = false; sb.disabled = false;
      toast("The wheel is catching its breath. Try again in a minute.");
      return;
    }
    const finish = async s => {
      spinning = false;
      ls.set("cb-discount", JSON.stringify({ pct: +s.pct, code: s.code }));
      $("#wcopy").innerHTML = wonView(s, !!repeat);
      try { cartState = await api("/cart/update.js", { discount: s.code }); } catch (e) {}
      renderCart();
    };
    if (repeat || idx < 0) { finish(prize); return; }
    subscribe(email, "spin-wheel, won-pct: " + prize.pct).catch(() => {});
    const a = 360 / S.length, jitter = (Math.random() - 0.5) * a * 0.6;
    wheelRot = wheelRot - (wheelRot % 360) + 360 * 6 + (360 - (idx * a + a / 2) + jitter);
    $("#wheel").style.transform = `rotate(${wheelRot}deg)`;
    const done = () => finish(prize);
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) setTimeout(done, 1300);
    else $("#wheel").addEventListener("transitionend", done, { once: true });
  }

  /* ---------- shared chrome: nav, drawer, wheel ---------- */
  function initChrome() {
    const cb = $("#cartBtn"); if (once(cb, "Cart")) cb.addEventListener("click", () => openCart(true));
    const cc = $("#closeCart"); if (once(cc, "Close")) cc.addEventListener("click", () => openCart(false));
    const sc = $("#scrim"); if (once(sc, "Scrim")) sc.addEventListener("click", () => { openCart(false); if (!spinning) openWheel(false); });
    $$("[data-cart-root]").forEach(root => {
      if (!once(root, "Lines")) return;
      const setCodes = list => api("/cart/update.js", { discount: list.join(",") });
      const welcomeFlag = (code, off) => { const d = savedCode(); if (d && d.code === code) ls.set("cb-discount", JSON.stringify(Object.assign({}, d, { off }))); };
      root.addEventListener("submit", async e => {
        const f = e.target.closest("[data-codeform]"); if (!f) return; e.preventDefault();
        const inp = f.querySelector("input"), btn = f.querySelector("button"), code = inp.value.trim().toUpperCase().replace(/\s+/g, "");
        if (!code) { inp.focus(); return; }
        const prev = ((cartState && cartState.discount_codes) || []).map(x => String(x.code).toUpperCase()).filter(x => x !== code);
        btn.classList.add("busy");
        try {
          // codes never stack with each other here, so a new code replaces the old one
          cartState = await setCodes([code]);
          const hit = (cartState.discount_codes || []).find(x => String(x.code).toUpperCase() === code);
          if (isWelcome(code)) {
            welcomeFlag(code, false);
            if (!welcomeOk(cartState)) { cartState = await setCodes(prev); toast(`Your welcome code works on orders under ${bundleMin()} bags. Your bundle deal is already better.`); }
            else toast(hit && hit.applicable ? `${code} applied` : "Welcome code added. It applies at checkout with the email you spun with.");
          } else if (hit && hit.applicable) toast(`${code} applied`);
          else { cartState = await setCodes(prev); toast(`${code} isn't a valid code for this order`); }
          inp.value = ""; renderCart();
        } catch (err) { toast("Couldn't apply that code. Try again."); }
        finally { btn.classList.remove("busy"); }
      });
      root.addEventListener("click", async e => {
        const cl = e.target.closest("[data-clearbag]");
        if (cl) { clearBag(cl); return; }
        const rm = e.target.closest("[data-rmcode]");
        if (rm) {
          const chip = rm.closest(".cchip"), code = chip ? chip.querySelector("b").textContent : "";
          rm.classList.add("busy");
          try { if (isWelcome(code)) welcomeFlag(code, true); cartState = await setCodes(((cartState && cartState.discount_codes) || []).map(x => String(x.code).toUpperCase()).filter(x => x !== code)); renderCart(); }
          catch (err) { toast("Couldn't remove that code"); rm.classList.remove("busy"); }
          return;
        }
        const b = e.target.closest("button[data-key]");
        if (b) { stepLine(b.dataset.key, +b.dataset.step || 0); return; }
        const a = e.target.closest('[data-cart="checkout"]');
        if (a) {
          e.preventDefault();
          if (Object.keys(pend).length) { a.classList.add("busy"); await flushAll().catch(() => {}); a.classList.remove("busy"); }
          if (a.getAttribute("aria-disabled") === "true") { const n = cartState ? cartState.item_count : 0; toast(n ? `Minimum ${minBags()} bags per order. Add ${minBags() - n} more.` : "Your bag is empty"); return; }
          a.classList.add("busy");
          try { await flushAll(); await syncExtras(); } catch (err) {}
          location.href = a.href;
        }
      });
    });
    // wheel
    const m = $("#wheelModal");
    if (m && CFG.wheel.enabled && CFG.wheel.slices.length >= 2) {
      buildWheel();
      const maxPct = Math.max(...CFG.wheel.slices.filter(s => +s.weight > 0).map(s => +s.pct || 0));
      const ow = $("#openWheel"); if (ow) { ow.textContent = `Spin to win up to ${maxPct}% off`; if (once(ow, "Open")) ow.addEventListener("click", () => openWheel(true)); }
      const fw = $("#footWheel"); if (once(fw, "Open")) fw.addEventListener("click", () => openWheel(true));
      const cw = $("#closeWheel"); if (once(cw, "Close")) cw.addEventListener("click", () => { if (!spinning) openWheel(false); });
      const prior = savedCode();
      const wc = $("#wcopy");
      if (prior && $("#wform")) wc.innerHTML = wonView(prior);
      if (once(wc, "Wheel")) {
        wc.addEventListener("click", e => {
          if (e.target.closest("#noThanks")) openWheel(false);
          if (e.target.closest("#copyCode")) { const code = $("#wcode").textContent; (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(() => toast("Code copied"), () => { const rg = document.createRange(); rg.selectNodeContents($("#wcode")); const s = getSelection(); s.removeAllRanges(); s.addRange(rg); toast("Code selected, press copy"); }); }
          if (e.target.closest("#shopNow")) { openWheel(false); const shop = document.getElementById("shop"); if (shop) shop.scrollIntoView({ behavior: "smooth" }); else location.href = url("/#shop"); }
        });
        wc.addEventListener("submit", e => {
          if (e.target.id !== "wform") return; e.preventDefault();
          const em = $("#wemail").value.trim();
          if (!validEmail(em)) { toast("Enter your email to spin"); $("#wemail").focus(); return; }
          spin(em);
        });
      }
      if (!CFG.designMode && CFG.template !== "cart" && ls.get("cb-wheel-seen") !== "1" && !prior && once(m, "Auto"))
        setTimeout(() => { const dr = $("#drawer"); if (!(dr && dr.classList.contains("open"))) openWheel(true); }, 2200);
    } else {
      ["#openWheel", "#footWheel"].forEach(s => { const e = $(s); if (e) e.hidden = true; });
    }
    // mailto buttons (FAQ): the address lives in Site settings, never on the page
    $$("[data-mailto]").forEach(a => { a.href = `mailto:${CFG.contact}?subject=${encodeURIComponent(a.dataset.mailto)}`; });
    $$("[data-max-tier]").forEach(e => { const t = tiers(); if (t.length) e.textContent = t[t.length - 1].pct; });
  }

  /* ---------- home: build your bag ---------- */
  const plusI = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
  const xI = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17"/></svg>';
  const labelI = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="3" width="14" height="18" rx="2.5"/><path d="M9 8h6M9 12h6M9 16h4"/></svg>';
  /* back label (nutrition facts) sheet */
  function openLabel(k) {
    const f = F(k); if (!f.label) return;
    let d = $("#lblDlg");
    if (!d) {
      d = document.createElement("dialog"); d.id = "lblDlg"; d.className = "lbl"; d.setAttribute("aria-labelledby", "lblTitle");
      document.body.appendChild(d);
      d.addEventListener("click", e => { if (e.target === d || e.target.closest(".lbl-x")) d.close(); });
      d.addEventListener("close", () => { document.documentElement.classList.remove("lbl-open"); });
    }
    d.style.setProperty("--fc", FC[k]);
    d.innerHTML = `<div class="lbl-card"><div class="lbl-head"><div><div class="eyebrow">Back of the bag</div><h2 class="display" id="lblTitle">${esc(f.name)}</h2></div><button type="button" class="x lbl-x press" aria-label="Close">${xI}</button></div>
      <div class="lbl-img"><img src="${esc(f.label)}" alt="${esc(f.name)} nutrition facts and ingredients" width="1000" height="1600"></div></div>`;
    document.documentElement.classList.add("lbl-open");
    if (d.showModal) d.showModal(); else d.setAttribute("open", "");
  }
  const minusI = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M5 12h14"/></svg>';
  function setHomeTheme(f) {
    setFlavor(f, true);
    const i = ORDER.indexOf(f), pos = { [ORDER[i]]: "pos-c", [ORDER[(i + 2) % 3]]: "pos-l", [ORDER[(i + 1) % 3]]: "pos-r" };
    $$("#stage .bag").forEach(b => { b.classList.remove("pos-c", "pos-l", "pos-r"); b.classList.add(pos[b.dataset.f]); });
    const sb = $("#shelfBag"); if (sb) sb.src = F(f).img;
    $$("#switcher button").forEach(b => b.setAttribute("aria-pressed", b.dataset.f === f));
  }
  /* hero: glass arrows + swipe/drag to cycle flavors (drives the switcher and the whole site's colors) */
  const chevron = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${d < 0 ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7"}"/></svg>`;
  function cycleFlavor(dir) {
    const cur = ORDER.indexOf(document.documentElement.dataset.flavor || "spicy");
    const next = ORDER[(cur + dir + ORDER.length) % ORDER.length];
    setHomeTheme(next);
    const n = $(".stage-live"); if (n) n.textContent = `${F(next).name || next} selected`;
  }
  function initStageNav() {
    const stage = $("#stage"); if (!stage || !once(stage, "Nav")) return;
    const wrap = document.createElement("div"); wrap.className = "stage-wrap";
    stage.parentNode.insertBefore(wrap, stage); wrap.appendChild(stage);
    wrap.insertAdjacentHTML("beforeend",
      `<button type="button" class="stage-arrow prev glass press" data-dir="-1" aria-label="Previous flavor">${chevron(-1)}</button>` +
      `<button type="button" class="stage-arrow next glass press" data-dir="1" aria-label="Next flavor">${chevron(1)}</button>` +
      `<span class="stage-live" aria-live="polite"></span>`);
    wrap.addEventListener("click", e => { const a = e.target.closest(".stage-arrow"); if (a) cycleFlavor(+a.dataset.dir); });
    // drag / swipe: follow the finger a little, then snap to the next flavor past a threshold
    let g = null, suppress = false;
    stage.addEventListener("pointerdown", e => {
      if (e.button !== undefined && e.button !== 0) return;
      g = { x: e.clientX, y: e.clientY, id: e.pointerId, dx: 0, lock: null };
    });
    stage.addEventListener("pointermove", e => {
      if (!g || e.pointerId !== g.id) return;
      const dx = e.clientX - g.x, dy = e.clientY - g.y;
      if (!g.lock && Math.abs(dx) + Math.abs(dy) > 8) { g.lock = Math.abs(dx) > Math.abs(dy) ? "x" : "y"; if (g.lock === "x") { stage.setPointerCapture(e.pointerId); stage.classList.add("dragging"); } }
      if (g.lock !== "x") return;
      g.dx = dx; e.preventDefault();
      stage.style.transform = `translateX(${dx * 0.35}px) rotate(${dx * 0.01}deg)`;
    });
    const end = e => {
      if (!g || (e && e.pointerId !== g.id)) return;
      const { dx, lock } = g; g = null;
      stage.classList.remove("dragging"); stage.style.transform = "";
      if (lock === "x") {
        suppress = true; setTimeout(() => { suppress = false; }, 50);
        if (Math.abs(dx) > Math.min(90, stage.clientWidth * 0.12)) cycleFlavor(dx < 0 ? 1 : -1);
      }
    };
    stage.addEventListener("pointerup", end); stage.addEventListener("pointercancel", end);
    stage.addEventListener("click", e => { if (suppress) return; const b = e.target.closest(".bag"); if (b) setHomeTheme(b.dataset.f); });
    wrap.addEventListener("keydown", e => { if (e.key === "ArrowLeft") { e.preventDefault(); cycleFlavor(-1); } if (e.key === "ArrowRight") { e.preventDefault(); cycleFlavor(1); } });
    stage.querySelectorAll(".bag").forEach(b => b.setAttribute("draggable", "false"));
  }
  function renderBuilder() {
    const n = countOf(sel.counts), max = maxBags(), PRE = CFG.pre;
    $("#fcards").innerHTML = ORDER.map(k => {
      const c = sel.counts[k] || 0, f = F(k), ok = okFlavor(k);
      return `<article class="fcard ${c ? "has" : ""}" style="--fc:${FC[k]}">
        <a class="fimg" href="${esc(f.url || "#")}" aria-label="${esc(f.name)} details"><img src="${esc(f.img)}" alt="${esc(f.name)} bag" loading="lazy">${c ? `<span class="fbadge">×${c}</span>` : ""}${ok ? "" : `<span class="oos">${f.variant ? "Sold out" : "Coming soon"}</span>`}</a>
        <div class="fn">${esc(f.name)}</div>
        <div class="foz">4 oz bag · ${money(f.price || 0)}</div>
        <p class="fl">${esc(f.line)}</p>
        ${f.label ? `<button type="button" class="lblbtn press" data-label="${k}">${labelI}Nutrition facts</button>` : ""}
        <div class="stepper"><button type="button" class="minus press" data-k="${k}" data-d="-1" aria-label="Remove one ${esc(f.name)}" ${c ? "" : "disabled"}>${minusI}</button><output aria-label="${esc(f.name)} bags">${c}</output><button type="button" class="press" data-k="${k}" data-d="1" aria-label="Add one ${esc(f.name)}" ${n >= max || !ok ? "disabled" : ""}>${plusI}</button></div>
      </article>`;
    }).join("");
    $("#tiers").innerHTML = tierHTML(n);
    const next = tiers().find(t => t.min > n);
    $("#nudge").textContent = n === 0 ? "Tap + on any flavor to start your bag." : next ? `Add ${next.min - n} more bag${next.min - n > 1 ? "s" : ""} to unlock ${next.pct}% off${shipBags() && next.min === shipBags() ? " + free shipping" : ""}.` : `Max discount unlocked: ${pctFor(n)}% off every bag.`;
    const slotsN = Math.min(max, Math.max(n, next ? next.min : n, 3));
    const filled = []; ORDER.forEach(k => { for (let i = 0; i < (sel.counts[k] || 0); i++) filled.push(k); });
    $("#slots").innerHTML = Array.from({ length: slotsN }, (_, i) => filled[i] ? `<div class="slot full"><img src="${esc(F(filled[i]).img)}" alt=""><button type="button" class="sx press" data-k="${filled[i]}" aria-label="Remove one ${esc(F(filled[i]).name)}">${xI}</button></div>` : `<div class="slot"></div>`).join("");
    const subs = subsAvailable(); if (!subs) sel.sub = false;
    const FQ = freqs(); if (sel.freq >= FQ.length) sel.freq = 0;
    const full = fullOf(sel.counts), one = estimate(sel.counts, false), sub = subs ? estimate(sel.counts, true) : one;
    const subPct = subs && full ? Math.round((1 - subPrice(sel.counts, FQ[sel.freq]) / full) * 100) : 0;
    $("#plans").innerHTML = `
      <button type="button" class="plan press" data-s="0" aria-pressed="${!sel.sub}"><span class="radio"></span><span><b>${PRE ? "Pre-order" : "One-time purchase"}</b><small>${PRE ? "Pay today · ships by " + esc(CFG.shipDate) : (n ? money(one / n) + "/bag" : "Pick your flavors")}</small></span><span class="amt">${money(one)}</span></button>
      ${subs ? `<button type="button" class="plan press" data-s="1" aria-pressed="${sel.sub}"><span class="radio"></span><span><b>${esc(SUB().label)}${subPct > 0 ? " " + subPct + "%" : ""}</b><small>${n ? money(sub / n) + "/bag" : "Stacks on your bag discount"}</small></span><span class="amt">${n && sub < full ? `<s>${money(full)}</s>` : ""}${money(sub)}</span></button>`
        : `<div class="plan-note">${PRE && CFG.subs && CFG.subs.enabled !== false ? esc(SUB().label) + " opens when we launch." : ""}</div>`}`;
    $("#freq").innerHTML = FQ.map((f, i) => `<option value="${i}" ${i === sel.freq ? "selected" : ""}>${esc(freqLabel(f))}</option>`).join("");
    $("#freqRow").hidden = !sel.sub; $("#perks").hidden = !sel.sub || !$("#perks").children.length;
    const total = sel.sub ? sub : one;
    $("#btotal").innerHTML = `${n && total < full - 0.5 ? `<s>${money(full)}</s>` : ""}<span class="big">${money(total)}</span>`;
    $("#bper").textContent = n ? `${n} bag${n > 1 ? "s" : ""} · ${money(total / n)}/bag${full - total > 0.5 ? " · you save " + money(full - total) : ""}` : "";
    const ab = $("#addBtn"), need = Math.max(0, minBags() - n); ab.disabled = !n || need > 0; ab.textContent = !n ? "Pick a flavor to start" : need ? `Add ${need} more bag${need > 1 ? "s" : ""} (${minBags()} minimum)` : `${PRE ? "Pre-order" : "Add"} ${n} bag${n > 1 ? "s" : ""}${PRE ? "" : " to cart"}`;
    $("#shipNote").textContent = !n ? shipIntro() : shipLeft(n, total) > 0 ? shipTo(n, total) : "This bag ships free";
    const hp = $("#heroPrice"); if (hp) hp.textContent = money(estimate({ cinnamon: 1, ranch: 1, spicy: 1 }, false)).replace(".00", "");
  }
  function itemsFor(counts, sub) {
    const freqName = freqs()[sel ? sel.freq : 0];
    return ORDER.filter(k => counts[k] > 0 && okFlavor(k)).map(k => {
      const it = { id: F(k).variant, quantity: counts[k] };
      if (sub) { const p = (F(k).plans || []).find(x => x.name === freqName); if (p) it.selling_plan = p.id; }
      return it;
    });
  }
  function initHome() {
    const home = $(".cb-home"); if (!home || !once(home, "Home")) return;
    homeTimers.forEach(clearInterval); homeTimers = [];
    sel = { counts: {}, sub: false, freq: 0 };
    ORDER.forEach(k => { sel.counts[k] = okFlavor(k) ? 2 : 0; }); // a 6-bag mix shows the 15% tier
    sel.sub = subsAvailable() && !CFG.pre && SUB().start !== "once";
    const pk = $("#perks"), perks = SUB().perks == null ? null : SUB().perks.filter(Boolean); // null = never set in HQ: keep the defaults
    if (pk && perks) pk.innerHTML = perks.map(x => `<span>${esc(x)}</span>`).join("");
    $$(".fl-name").forEach(s => s.textContent = F(s.dataset.k).name);
    $$("#stage .bag").forEach(b => { b.src = F(b.dataset.f).img; b.alt = (F(b.dataset.f).name || "") + " bag"; });
    setHomeTheme(document.documentElement.dataset.flavor || "spicy");
    $("#switcher").addEventListener("click", e => { const b = e.target.closest("button"); if (b) setHomeTheme(b.dataset.f); });
    initStageNav();
    $("#fcards").addEventListener("click", e => {
      const lb = e.target.closest("[data-label]"); if (lb) { openLabel(lb.dataset.label); return; }
      const b = e.target.closest("button[data-k]"); if (!b || b.disabled) return;
      const k = b.dataset.k, d = +b.dataset.d, max = maxBags();
      if (d > 0 && countOf(sel.counts) >= max) { toast(`Max ${max} bags per order`); return; }
      sel.counts[k] = Math.max(0, (sel.counts[k] || 0) + d); if (d > 0) setHomeTheme(k); renderBuilder();
    });
    $("#slots").addEventListener("click", e => { const b = e.target.closest(".sx"); if (!b) return; const k = b.dataset.k; sel.counts[k] = Math.max(0, (sel.counts[k] || 0) - 1); renderBuilder(); });
    $("#plans").addEventListener("click", e => { const b = e.target.closest(".plan"); if (!b) return; sel.sub = b.dataset.s === "1"; renderBuilder(); });
    $("#freq").addEventListener("change", e => { sel.freq = +e.target.value; renderBuilder(); });
    $("#oneEach").addEventListener("click", () => { ORDER.forEach(k => { if (okFlavor(k) && countOf(sel.counts) < maxBags()) sel.counts[k] = (sel.counts[k] || 0) + 1; }); renderBuilder(); });
    $("#clearBag").addEventListener("click", () => { ORDER.forEach(k => sel.counts[k] = 0); renderBuilder(); });
    $("#addBtn").addEventListener("click", () => { if (countOf(sel.counts)) addItems(itemsFor({ ...sel.counts }, sel.sub), [$("#addBtn")]); });
    $("#heroSampler").addEventListener("click", () => addItems(itemsFor({ cinnamon: 1, ranch: 1, spicy: 1 }, false), [$("#heroSampler")]));

    // reviews: each stays up 4s, then the next slides in. Arrows, dots and swipes move it; hovering or focusing pauses it.
    const Q = $$("#qstack .qitem"), qcard = $("#qcard"), dots = $("#qDots"), QDUR = 4000;
    let qInt = null, qHold = false;
    const qRun = () => {
      clearInterval(qInt); homeTimers = homeTimers.filter(t => t !== qInt); qInt = null;
      if (dots) { dots.style.setProperty("--qdur", QDUR + "ms"); dots.classList.remove("run"); void dots.offsetWidth; dots.classList.toggle("run", Q.length > 1 && !qHold && !document.hidden); }
      if (Q.length > 1 && !qHold && !document.hidden) { qInt = setInterval(() => showQ(qi + 1, 1, true), QDUR); homeTimers.push(qInt); }
    };
    const showQ = (i, dir, auto) => {
      if (!Q.length) return;
      const prev = qi; qi = (i + Q.length) % Q.length;
      Q.forEach((el, j) => { el.classList.toggle("on", j === qi); el.classList.toggle("out", j === prev && prev !== qi); el.dataset.dir = dir < 0 ? "back" : "fwd"; el.setAttribute("aria-hidden", j !== qi); });
      $$("#qDots button").forEach((b, j) => b.setAttribute("aria-current", j === qi));
      if (!auto) qRun(); else if (dots) { dots.classList.remove("run"); void dots.offsetWidth; dots.classList.add("run"); }
    };
    qi = 0;
    if (dots) dots.addEventListener("click", e => { const i = [...dots.children].indexOf(e.target.closest("button")); if (i > -1 && i !== qi) showQ(i, i > qi ? 1 : -1); });
    if (qcard && Q.length > 1) {
      qcard.addEventListener("click", e => { const b = e.target.closest("[data-qstep]"); if (b) showQ(qi + +b.dataset.qstep, +b.dataset.qstep); });
      const hold = on => { if (qHold === on) return; qHold = on; qcard.classList.toggle("hold", on); qRun(); };
      const canHover = matchMedia("(hover: hover) and (pointer: fine)").matches, kbFocus = () => { const a = document.activeElement; return !!(a && qcard.contains(a) && a.matches(":focus-visible")); };
      if (canHover) { qcard.addEventListener("mouseenter", () => hold(true)); qcard.addEventListener("mouseleave", () => hold(kbFocus())); }
      qcard.addEventListener("focusin", () => hold(kbFocus() || (canHover && qcard.matches(":hover")))); qcard.addEventListener("focusout", e => { if (!qcard.contains(e.relatedTarget)) hold(canHover && qcard.matches(":hover")); });
      document.addEventListener("visibilitychange", qRun);
      // swipe on touch screens
      let sx = null, sy = 0;
      qcard.addEventListener("pointerdown", e => { if (e.pointerType !== "mouse") { sx = e.clientX; sy = e.clientY; } }, { passive: true });
      qcard.addEventListener("pointerup", e => { if (sx == null) return; const dx = e.clientX - sx, dy = e.clientY - sy; sx = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) showQ(qi + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); }, { passive: true });
      qRun();
    }

    // flavor lab
    const opts = $("#opts");
    opts.addEventListener("click", e => {
      const b = e.target.closest(".q"); if (!b || opts.classList.contains("locked")) return; const on = b.getAttribute("aria-pressed") === "true";
      opts.querySelectorAll(".q").forEach(x => { x.setAttribute("aria-pressed", !on && x === b); x.querySelector(".qv").textContent = (!on && x === b) ? "Your pick" : "Tap to vote"; });
      opts.classList.toggle("picked", !on);
    });
    // one vote per person: remembered on this device, and the CRM sheet checks the email
    const voted = v => {
      opts.querySelectorAll(".q").forEach(x => { const me = x.querySelector(".qn").textContent.trim() === v; x.setAttribute("aria-pressed", me); x.disabled = true; x.querySelector(".qv").textContent = me ? "Your vote" : ""; });
      opts.classList.add("picked", "locked");
      $("#vform").hidden = true;
    };
    const prior = ls.get("cb-voted");
    if (prior) { voted(prior); const t = $("#thanks"); t.hidden = false; t.textContent = `You voted for ${prior}. Thanks! One vote per person.`; }
    $("#vform").addEventListener("submit", async e => {
      e.preventDefault();
      const p = $("#opts .q[aria-pressed='true'] .qn"), t = $("#thanks"), em = $("#vemail").value.trim();
      t.hidden = false;
      if (!p) { t.textContent = "Pick a flavor first, then cast your vote."; return; }
      if (!validEmail(em)) { t.textContent = "Add your email so we can tell you when it drops."; $("#vemail").focus(); return; }
      const pick = p.textContent.trim(), btn = e.target.querySelector("button"); btn.classList.add("busy");
      try {
        let j = null;
        try { j = await crm({ type: "vote", email: em, vote: pick }); } catch (err) { if (CFG.crm) throw err; }
        if (!CFG.crm) await subscribe(em, "flavor-vote, vote: " + pick);
        else if (!j || !j.ok) throw new Error("vote");
        else subscribe(em, "flavor-vote, vote: " + pick).catch(() => {});
        const v = j && j.repeat ? j.vote || pick : pick;
        ls.set("cb-voted", v); voted(v);
        t.textContent = j && j.repeat ? `This email already voted for ${v}. One vote per person.` : `Vote for ${v} counted. Watch your inbox for the drop.`;
      }
      catch (err) { t.textContent = "Couldn't save your vote. Try again in a moment."; }
      finally { btn.classList.remove("busy"); }
    });

    initMap();
    renderBuilder();
  }

  /* ---------- home: map (Leaflet + OpenStreetMap, loaded only when the map nears the screen) ---------- */
  const LEAFLET = {
    css: "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css", cssI: "sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=",
    js: "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js", jsI: "sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo="
  };
  const LA = [34.08, -118.33];
  let lmap = null, markers = {}, mFilter = "all", activeLoc = null, LOCS = [], mapIO = null;
  function loadLeaflet() {
    if (window.L && window.L.map) return Promise.resolve(window.L);
    if (loadLeaflet.p) return loadLeaflet.p;
    loadLeaflet.p = new Promise((res, rej) => {
      const l = document.createElement("link"); l.rel = "stylesheet"; l.href = LEAFLET.css; l.integrity = LEAFLET.cssI; l.crossOrigin = "anonymous"; document.head.appendChild(l);
      const s = document.createElement("script"); s.src = LEAFLET.js; s.integrity = LEAFLET.jsI; s.crossOrigin = "anonymous"; s.async = true;
      s.onload = () => (window.L && window.L.map ? res(window.L) : rej(new Error("leaflet"))); s.onerror = () => { loadLeaflet.p = null; rej(new Error("leaflet")); };
      document.head.appendChild(s);
    });
    return loadLeaflet.p;
  }
  const PIN = c => `<svg viewBox="0 0 38 46" aria-hidden="true"><path d="M19 45C19 45 3 28 3 17a16 16 0 0 1 32 0c0 11-16 28-16 28z" style="fill:${c}" stroke="#fff" stroke-width="2.5"/><circle cx="19" cy="17" r="6" fill="#fff"/></svg>`;
  const ICON = { market: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10l2-6h14l2 6M4 10v10h16V10M3 10h18M9 20v-6h6v6"/></svg>', store: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>' };
  const hasPt = l => isFinite(l.lat) && isFinite(l.lng);
  const visLocs = () => LOCS.filter(l => mFilter === "all" || l.type === mFilter);
  function renderLocs() {
    const V = visLocs();
    $("#mlist").innerHTML = V.length ? V.map(l => `<button type="button" class="mrow press" data-id="${esc(l.id)}" aria-current="${activeLoc === l.id}"><span class="mi" style="background:${l.type === "market" ? "var(--deep)" : "var(--ink)"}">${ICON[l.type] || ICON.store}</span><span><b>${esc(l.name)}</b><span>${esc(l.address)}</span><span>${esc(l.when || "")}</span></span></button>`).join("")
      : `<div class="mempty">${LOCS.length ? "Nothing here for this filter yet." : (CFG.designMode ? "Add markets and stores in Canyon Bites HQ and they show up here and on the map." : "Markets and stores coming soon. Order online in the meantime.")}</div>`;
    if (lmap) {
      const ids = new Set(V.map(l => l.id));
      Object.keys(markers).forEach(id => {
        const m = markers[id];
        if (ids.has(id)) { if (!lmap.hasLayer(m)) m.addTo(lmap); } else if (lmap.hasLayer(m)) m.remove();
        const el = m.getElement(); if (el) el.classList.toggle("on", activeLoc === id);
      });
    }
    positionCard();
  }
  function positionCard() {
    const c = $("#mcard"), l = LOCS.find(x => x.id === activeLoc);
    if (!c || !l || !lmap || !hasPt(l)) return;
    const p = lmap.latLngToContainerPoint([l.lat, l.lng]), sz = lmap.getSize();
    const x = p.x / sz.x * 100, y = p.y / sz.y * 100;
    c.style.left = Math.max(22, Math.min(78, x)) + "%"; c.style.top = y + "%"; c.classList.toggle("below", y < 48);
  }
  const setVB = () => { if (lmap) lmap.invalidateSize(); positionCard(); };
  function closeCard() { activeLoc = null; const c = $("#mcard"); if (c) c.classList.remove("open"); renderLocs(); }
  function openLoc(id, center) {
    activeLoc = id; const l = LOCS.find(x => x.id === id), c = $("#mcard");
    if (!l || !hasPt(l)) { c.classList.remove("open"); renderLocs(); return; }
    c.innerHTML = `<button type="button" class="xx press" aria-label="Close">✕</button><div class="eyebrow" style="font-size:11px">${l.type === "market" ? "Farmers market" : "Store"}</div><b>${esc(l.name)}</b><p>${esc(l.address)}${l.when ? `<br>${esc(l.when)}` : ""}</p><a href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(l.name + " " + l.address)}" target="_blank" rel="noopener">Directions</a>`;
    c.querySelector(".xx").onclick = closeCard;
    if (center && lmap) lmap.setView([l.lat, l.lng], Math.max(lmap.getZoom(), 13), { animate: true });
    renderLocs(); requestAnimationFrame(() => { positionCard(); c.classList.add("open"); });
  }
  function fitAll() {
    if (!lmap) return;
    const P = visLocs().filter(hasPt);
    if (!P.length) lmap.setView(LA, 10);
    else if (P.length === 1) lmap.setView([P[0].lat, P[0].lng], 13);
    else lmap.fitBounds(P.map(l => [l.lat, l.lng]), { padding: [60, 60], maxZoom: 13 });
  }
  function buildMap(L) {
    const el = $("#lmap"); if (!el || el._cb) return; el._cb = true;
    lmap = L.map(el, { zoomControl: false, scrollWheelZoom: false, dragging: !L.Browser.mobile, tap: false, attributionControl: true });
    lmap.attributionControl.setPrefix(false);
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>' }).addTo(lmap);
    markers = {};
    LOCS.filter(hasPt).forEach(l => {
      const m = L.marker([l.lat, l.lng], { title: l.name, alt: l.name, riseOnHover: true, icon: L.divIcon({ className: "cbpin", html: PIN(l.type === "market" ? "var(--deep)" : "var(--ink)"), iconSize: [38, 46], iconAnchor: [19, 46] }) });
      m.on("click", () => openLoc(l.id, false));
      markers[l.id] = m;
    });
    fitAll(); renderLocs();
    lmap.on("move zoom resize", positionCard);
    lmap.on("click", () => { if (activeLoc) closeCard(); });
    $("#map").classList.add("ready");
  }
  function initMap() {
    const map = $("#map"); if (!map) return;
    let raw = []; try { raw = JSON.parse(($("#cb-locations") || {}).textContent || "[]"); } catch (e) {}
    LOCS = raw.map(l => ({ ...l, lat: parseFloat(l.lat), lng: parseFloat(l.lng) })).sort((a, b) => (a.type === b.type ? 0 : a.type === "market" ? -1 : 1) || String(a.name).localeCompare(b.name));
    activeLoc = null; mFilter = "all"; lmap = null; markers = {};
    renderLocs();
    $("#mlist").addEventListener("click", e => { const b = e.target.closest(".mrow"); if (b) openLoc(b.dataset.id, true); });
    $("#mfilter").addEventListener("click", e => { const b = e.target.closest("button"); if (!b) return; mFilter = b.dataset.t; $$("#mfilter button").forEach(x => x.setAttribute("aria-pressed", x === b)); activeLoc = null; $("#mcard").classList.remove("open"); renderLocs(); fitAll(); });
    $("#zin").addEventListener("click", () => lmap && lmap.zoomIn()); $("#zout").addEventListener("click", () => lmap && lmap.zoomOut());
    const go = () => loadLeaflet().then(buildMap).catch(() => map.classList.add("failed"));
    if (mapIO) mapIO.disconnect();
    if ("IntersectionObserver" in window) { mapIO = new IntersectionObserver(es => { if (es.some(x => x.isIntersecting)) { mapIO.disconnect(); go(); } }, { rootMargin: "600px 0px" }); mapIO.observe(map); }
    else go();
  }

  /* ---------- product page ---------- */
  function initProduct() {
    const root = $("[data-pdp]"); if (!root || !once(root, "Pdp")) return;
    let P; try { P = JSON.parse(root.querySelector("[data-pdp-json]").textContent); } catch (e) { return; }
    P.plans = P.requiresPlan ? (plansOf(P.plans).length ? plansOf(P.plans) : P.plans) : plansOf(P.plans);
    const q = s => root.querySelector(s);
    // 3-pack pages: PK = bags per pack. The stepper counts packs, discount tiers count bags,
    // and "Add" puts the real bags in the cart so minimums, bag discounts and free shipping all count bags.
    const PK = P.pack && P.pack.length ? (P.packSize || 3) : 0, U = PK ? "pack" : "bag";
    const st = { qty: PK ? 1 : Math.max(3, minBags()), sub: false, freq: 0 };
    const subs = CFG.subsOn && P.plans.length > 0;
    if (P.requiresPlan && !subs) { const b = q("[data-pdp-add]"); if (b) { b.disabled = true; b.textContent = "Opens at launch"; } }
    st.sub = subs && ((!CFG.pre && SUB().start !== "once") || P.requiresPlan);
    const line = q("[data-pdp-line]"); if (line) line.textContent = F(P.key).line || "";
    if (line && F(P.key).label && !q(".lblbtn")) { line.insertAdjacentHTML("afterend", `<button type="button" class="lblbtn press pdp-lbl" data-label="${esc(P.key)}">${labelI}Nutrition facts &amp; ingredients</button>`); }
    function render() {
      const n = st.qty, nb = PK ? n * PK : n, pct = pctFor(nb), plan = P.plans[st.freq];
      const subUnit = plan ? plan.price : P.price, unit = st.sub ? subUnit : P.price;
      const one = n * P.price * (1 - pct / 100), sub = n * subUnit * (1 - pct / 100), full = n * P.price;
      q("[data-pdp-qty]").textContent = n;
      q("[data-pdp-plans]").innerHTML = `
        ${P.requiresPlan ? "" : `<button type="button" class="plan press" data-s="0" aria-pressed="${!st.sub}"><span class="radio"></span><span><b>${CFG.pre ? "Pre-order" : "One-time purchase"}</b><small>${CFG.pre ? "Pay today · ships by " + esc(CFG.shipDate) : money(one / n) + "/" + U}</small></span><span class="amt">${one < full - 0.5 ? `<s>${money(full)}</s>` : ""}${money(one)}</span></button>`}
        ${subs ? `<button type="button" class="plan press" data-s="1" aria-pressed="${st.sub}"><span class="radio"></span><span><b>${esc(SUB().label)}</b><small>${money(sub / n)}/${U}${SUB().note ? " · " + esc(SUB().note) : ""}</small></span><span class="amt">${sub < full - 0.5 ? `<s>${money(full)}</s>` : ""}${money(sub)}</span></button>` : (CFG.pre && CFG.subs && CFG.subs.enabled !== false ? `<div class="plan-note">${esc(SUB().label)} opens when we launch.</div>` : "")}`;
      const fr = q("[data-pdp-freqrow]"); fr.hidden = !st.sub;
      q("[data-pdp-freq]").innerHTML = P.plans.map((p, i) => `<option value="${i}" ${i === st.freq ? "selected" : ""}>${esc(planLabel(p))}</option>`).join("");
      q("[data-pdp-price]").textContent = money(unit) + " / " + U;
      const next = tiers().find(t => t.min > nb);
      q("[data-pdp-tiers]").innerHTML = `<div class="tiers">${tierHTML(nb)}</div><p class="nudge">${next ? `Add ${PK ? (m => m + " more pack" + (m > 1 ? "s" : ""))(Math.ceil((next.min - nb) / PK)) : next.min - nb + " more"} to unlock ${next.pct}% off${shipBags() && next.min === shipBags() ? " + free shipping" : ""}.` : `Max discount unlocked: ${pct}% off every bag.`}</p>`;
      const add = q("[data-pdp-add]");
      if (add && !add.disabled) add.textContent = `${CFG.pre && !st.sub ? "Pre-order" : "Add"} ${n} ${U}${n > 1 ? "s" : ""} · ${money(st.sub ? sub : one)}`;
    }
    root.addEventListener("click", e => {
      const lb = e.target.closest("[data-label]"); if (lb) { openLabel(lb.dataset.label); return; }
      const qb = e.target.closest("[data-pdp-q]");
      if (qb) { st.qty = PK ? Math.max(1, Math.min(Math.floor(maxBags() / PK), st.qty + +qb.dataset.pdpQ)) : Math.max(minBags(), Math.min(maxBags(), st.qty + +qb.dataset.pdpQ)); render(); return; }
      const pb = e.target.closest(".plan"); if (pb) { st.sub = pb.dataset.s === "1"; render(); return; }
      const ab = e.target.closest("[data-pdp-add]");
      if (ab && !ab.disabled) {
        if (PK) { addItems(P.pack.map(c => ({ id: c.id, quantity: c.q * st.qty })), [ab]); return; }
        const it = { id: P.variant, quantity: st.qty };
        if (st.sub && P.plans[st.freq]) it.selling_plan = P.plans[st.freq].id;
        addItems([it], [ab]);
      }
    });
    q("[data-pdp-freq]").addEventListener("change", e => { st.freq = +e.target.value; render(); });
    render();
  }

  /* ---------- collection quick add ---------- */
  function initCollection() {
    $$("[data-quick-add]").forEach(b => {
      if (!once(b, "Qa")) return;
      b.addEventListener("click", () => addItems([{ id: +b.dataset.quickAdd, quantity: 1 }], [b]));
    });
    $$("[data-flavor-card]").forEach(c => c.style.setProperty("--fc", FC[c.dataset.flavorCard] || "var(--flav)"));
  }

  /* ---------- boot ---------- */
  function init() {
    if (!readCfg()) return;
    $$("[data-ship-date]").forEach(e => e.textContent = CFG.shipDate);
    initChrome();
    initHome();
    initProduct();
    initCollection();
    renderCart();
    loadCart();
  }
  if (!window.__cbGlobal) {
    window.__cbGlobal = true;
    addEventListener("resize", () => setVB());
    addEventListener("scroll", () => { const h = $(".hero") || $(".pdp") || $(".page-head"); document.documentElement.classList.toggle("scrolled", scrollY > (h && h.classList.contains("hero") ? h.offsetHeight - 90 : 40)); }, { passive: true });
    document.addEventListener("keydown", e => { if (e.key === "Escape") { if (!spinning) openWheel(false); openCart(false); } });
    document.addEventListener("shopify:section:load", () => { setTimeout(init, 0); });
    addEventListener("pageshow", e => { if (e.persisted && CFG) loadCart(); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
